import React from "react";
import GenericMasterPage from "@/pages/GenericMasterPage";

export default function EmployeesPage() {
  return (
    <GenericMasterPage
      resourcePath="employees"
      testIdPrefix="employee"
      title="Installation Employees"
      description="Field engineers who perform installations."
      fields={[{ key: "name", label: "Employee Name", required: true, placeholder: "e.g. Ravi Kumar" }]}
      displayKeys={["name"]}
    />
  );
}
